import { useOverflowContext } from './overflowContext';
/**
 * @returns Number of items that are overflowing
 */
export const useOverflowCount = () => useOverflowContext(v => {
  return Object.entries(v.itemVisibility).reduce((acc, _ref) => {
    let [id, visible] = _ref;
    if (!visible) {
      acc++;
    }
    return acc;
  }, 0);
});